import {
  VuexModule,
  Module,
  Action,
  Mutation,
  getModule
} from "vuex-module-decorators";
// 引入登录相关的接口
import {
  login,
  teacherLogin,
  teacherLoginOut,
  shoolLoginOut,
  getAccessToken,
  getCurrUserMenuTree,
  resetPwd,
  loginBySms,
  getTeacherUserByMobile
} from "@/api/login";
// 引入token相关的方法
import {
  getToken, setToken, removeToken,
  getMenuFlag, setLoadMenuFlag, removeMenuFlag
} from "@/utils/auth";
// 引入路由
import router from "@/router";
// 引入tagsView模块
import { TagsViewModule } from "./tagsView";
// 引入仓库
import store from "@/store";
// 引入 cookie 操作
import Cookies from "js-cookie";
//引入消息弹框组件
import { Message } from "element-ui";
import { getTeacherUser, getUser } from "@/api/login"

export interface IUserState {
  token: string;
  loadMenu: boolean;
  testLog: boolean;
  verificationCode: string;
  userName: string;
}

@Module({dynamic: true, store, name: "user"})
class User extends VuexModule implements IUserState {
  public token = getToken() || "";
  public loadMenu = false;
  //TODO: testLog 为开发阶段的测试值，登录接口跑通，拿到token后，要把testLog删掉
  public testLog = false;
  public verificationCode = '';
  public userName = '';

  @Mutation
  private SET_TOKEN(token: string) {
    this.token = token;
  }

  @Mutation
  private SET_VERIFYCODE(verificationCode: string) {
    this.verificationCode = verificationCode;
  }

  @Mutation
  private SET_LOAD_MENUS(loadMenu: boolean) {
    this.loadMenu = loadMenu;
  }

  //TODO: SET_LOG 为开发阶段的测试值，登录接口跑通，拿到token后，要把 SET_LOG 删掉
  @Mutation
  private SET_LOG(status: boolean) {
    this.testLog = status;
  }

  @Mutation
  private SET_Name(status: string) {
    this.userName = status;
  }

  //专家系统自身登录-学校
  //接口出来后，可以参考下面“专家系统自身登录-教师”的处理方式，处理登录逻辑。
  @Action
  public async SchoolLogin(userInfo: { username: string; password: string; phoneCode: string; key: string }) {
    // this.SET_LOG(true);
    try {
      let {username, password, phoneCode, key} = userInfo;
      username = username.trim();
      //获取token
      // const { data } = await login({ username, password });
      const {data} = await login({username, password, phoneCode, key});
      if (data) {
        setToken(data);
        this.SET_TOKEN(data);
        this.SET_LOAD_MENUS(true);
        sessionStorage.setItem("isSchoolLogin", "TRUE")
        sessionStorage.setItem("isLoadMenu", "yes") // 存储 isLoadMenu 值为 yes
        setLoadMenuFlag("yes")
        const userName = await getUser();
        if (userName.data && userName.data !== null) {
          this.setUserName(userName.data);
          return userName;
        }
      }
    } catch (error) {
      const msg = error.mesg || error

      Message.error(msg)
      if (msg === '验证码不正确') {
        throw(msg)
      }
    }
  }

  //专家系统自身登录-教师
  @Action
  public async TeacherLogin(userInfo: { loginAccount: string; loginPassword: string, phoneCode: string, key: string }) {
    let {loginAccount, loginPassword, phoneCode, key} = userInfo;
    loginAccount = loginAccount.trim();
    //获取token
    try {
      const {data} = await teacherLogin({loginAccount, loginPassword, phoneCode, key});
      if (data) {
        setToken(data);
        this.SET_TOKEN(data);
        this.SET_LOAD_MENUS(true);
        sessionStorage.setItem("isTeacherLogin", "TRUE")
        sessionStorage.setItem("isLoadMenu", "yes")
        setLoadMenuFlag("yes")
        const userName = await getTeacherUser();
        if (userName.data && userName.data !== null) {
          this.setUserName(userName.data);
          return userName;
        }
      }
    } catch (error) {
      const msg = error.mesg || error

      Message.error(msg)
      if (msg === '验证码不正确') {
        throw(msg)
      }
    }
  }

  @Action
  public async TeacherLoginBySms(params) {
    //获取token
    try {
      const {data} = await loginBySms(params);
      if (data) {
        setToken(data);
        this.SET_TOKEN(data);
        this.SET_LOAD_MENUS(true);
        sessionStorage.setItem("isTeacherLogin", "TRUE")
        sessionStorage.setItem("isLoadMenu", "yes")
        setLoadMenuFlag("yes")
        const userName = await getTeacherUserByMobile({teacherPhone: params.mobile});
        if (userName.data && userName.data !== null) {
          this.setUserName(userName.data);
          return userName;
        }
      }
    } catch (error) {
      const msg = error.mesg || error

      Message.error(msg)
    }
  }

  //统一身份认证-获取 Access Token
  @Action
  public async GetAccessToken(params: Object) {
    try {
      let res = await getAccessToken(params);
      if (res!.data!.resultData === null) {
        let msg: string = res.data.message;
        Message.error(msg);
      } else {
        //设置token
        setToken(res.data.access_token);
        this.SET_TOKEN(res.data.access_token);
        sessionStorage.setItem("isUniteLogin", "TRUE")
        this.SET_LOAD_MENUS(true);
        sessionStorage.setItem("isSchoolLogin", "TRUE")
        sessionStorage.setItem("isLoadMenu", "yes") // 存储 isLoadMenu 值为 yes
        setLoadMenuFlag("yes")
        let userName = await getUser();
        if (userName.data && userName.data !== null) {
          this.setUserName(userName.data)
        }
      }
    } catch (error) {
      Message.error(error.mesg)
    }
  }

  // 清空 置 loadMenu 为false状态
  @Action
  public updateLoadMenu() {
    this.SET_LOAD_MENUS(false);
    sessionStorage.removeItem("isLoadMenu")
    removeMenuFlag()
  }

  @Action
  public updateLoadMenu4Refresh() {
    this.SET_LOAD_MENUS(true);
    // this.SET_LOAD_MENUS(Boolean(sessionStorage.loadMenu == "isLoadMenu"));
    sessionStorage.setItem("isLoadMenu", "yes")
    setLoadMenuFlag("yes")
  }

  @Action
  public ResetToken() {
    this.SET_TOKEN("");
    removeToken();
    removeMenuFlag()
    // 清除菜单加载标识 cookie，防止刷新后误判已登录
    Cookies.remove("isLoadMenu")
    sessionStorage.removeItem("isSchoolLogin")
    sessionStorage.removeItem("isTeacherLogin")
    sessionStorage.removeItem("isUniteLogin")
  }

  @Action
  public setVerifyCode(verificationCode) {
    this.SET_VERIFYCODE(verificationCode);
  }


  @Action
  public setUserName(name) {
    this.SET_Name(name);
  }

  @Action
  public getVerifyCode(verificationCode) {
    return this.verificationCode;
  }

  @Action
  //退出有害信息系统的登录
  public async LogOut() {
    // 加个判断 是 school shoolLoginOut  还是 teacher teacherLoginOut 的登出
    let isSchoolLogin = sessionStorage.isSchoolLogin
    let isTeacherLogin = sessionStorage.isTeacherLogin
    let isUniteLogin = sessionStorage.isUniteLogin

    if (isSchoolLogin && isSchoolLogin == "TRUE") {
      await shoolLoginOut();
      sessionStorage.removeItem("isSchoolLogin")
    }
    if (isTeacherLogin && isTeacherLogin == "TRUE") {
      await teacherLoginOut()
      sessionStorage.removeItem("isTeacherLogin")
    }
    if (isUniteLogin && isUniteLogin == "TRUE") {
      //退出统一身份认证的登录
      window.location.href = window.config.loginBaseUrl + '/loginOut?tk='+this.token;
    }
    sessionStorage.removeItem("isLoadMenu");
    sessionStorage.removeItem("permissions");
    sessionStorage.removeItem("isUniteLogin")
    removeMenuFlag();
    removeToken();
    TagsViewModule.delAllViews();
    this.SET_TOKEN("");
    sessionStorage.removeItem("access_token")
  }

  @Action
  // 修改密码
  public async ResetPwd(data) {
    try {
      let res = await resetPwd(data)
      return res;
    } catch (error) {
      Message.error(error || "修改密码失败")
    }
  }
}

export const UserModule = getModule(User);
